import { render, staticRenderFns } from "./submission-agent.vue?vue&type=template&id=c21f1816"
import script from "./submission-agent.vue?vue&type=script&lang=js"
export * from "./submission-agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports